import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "@mui/material"
import { CMForgotPasswordModal } from "./forgot-password-modal.styles"
import ForgotPasswordInputEmail from "./forgot-password-input-email/forgot-password-input-email.component";
import ForgotPasswordConfirmationMessage from "./forgot-password-confirmation-message/forgot-password-confirmation-message.component";
import { Formik } from "formik";
import * as Yup from 'yup';
import { CMInput } from "./forgot-password-modal.styles";

const getStep = activeStep => (
    {
        1: ForgotPasswordInputEmail,
        2: ForgotPasswordConfirmationMessage
    }[activeStep]
)

const ForgotPasswordModal = ({open, openStep, handleClose, onClose, ...props}) => {    
    const [activeStep, setActiveStep] = useState(openStep);
    const [refresh, setRefresh] = useState(false);
    const CMStep = getStep(activeStep);
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [initialValues] = useState({
        email: '',
    })

    useEffect(() => {
        setActiveStep(openStep);
    }, [openStep]);

    const validationSchema = Yup.object({
        email: Yup.string()
        .email('Invalid email format')
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required'),
      });

    const handleNext = () => {
        setActiveStep(value => value + 1);
    }

    return (
        <Modal open={open} onClose={handleClose} {...props}>
            <CMForgotPasswordModal className="center-absolute">
            <Formik
                initialValues={initialValues}
                onSubmit={handleNext}
                validationSchema={validationSchema}
            >
            {(formProps) => (
                <CMStep handleNext={handleNext} formProps={formProps} />

            )}
                </Formik>
            </CMForgotPasswordModal>
        </Modal>
    )
}

export default ForgotPasswordModal